import {
  FLYWAYS_MAP_SVG_PATH,
  FLYWAYS_MAP_SVG_ROOT_ATTR,
} from '@/constants/flywaysMap';

const XML_DECLARATION = /^\s*<\?xml[^>]*>\s*/i;
const SVG_OPEN_TAG = /<svg\b([^>]*)>/i;

let svgMarkupPromise: Promise<string> | null = null;

/**
 * Strip XML declaration + fixed width/height; mark the root for the island
 * contract and set preserveAspectRatio to match the former SSR normalizer.
 * ViewBox is applied by the interactive island after inject (default camera
 * for LTR/RTL + compact).
 */
export function normalizeFlywaysMapSvgMarkup(text: string): string {
  return text
    .replace(XML_DECLARATION, '')
    .replace(SVG_OPEN_TAG, (_match, attrs: string) => {
      const cleaned = attrs
        .replace(/\swidth="[^"]*"/i, '')
        .replace(/\sheight="[^"]*"/i, '')
        .replace(/\spreserveAspectRatio="[^"]*"/i, '')
        .replace(new RegExp(`\\s${FLYWAYS_MAP_SVG_ROOT_ATTR}(?:=(?:"[^"]*"|'[^']*'|\\S+))?`, 'i'), '');
      return `<svg${cleaned} ${FLYWAYS_MAP_SVG_ROOT_ATTR} preserveAspectRatio="xMidYMid slice">`;
    })
    .trim();
}

/**
 * Fetch and cache the processed flyways map SVG (public asset).
 * Primary load path for the map island (no SSR-inlined plate).
 * Strips XML declaration / fixed size attrs and applies root contract attrs.
 */
export function loadFlywaysMapSvg(): Promise<string> {
  svgMarkupPromise ??= fetch(FLYWAYS_MAP_SVG_PATH)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load flyways map SVG (${response.status})`);
      }
      return response.text();
    })
    .then((text) => normalizeFlywaysMapSvgMarkup(text));

  return svgMarkupPromise;
}
